export const googlePlayApiConfig = {
  clientId: process.env.VUE_APP_GOOGLE_PLAY_CLIENT_ID,
  scope:
    "https://www.googleapis.com/auth/androidpublisher https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"
};
